export default __webpack_public_path__ + "d0316bf95b135611d4be791b439bb3e2.ttf";